<script>
    export default {
        name: "Pagination Table",
        props: {
            tableName: {
              type: String,
              required: false
            },
            data: {
                type: Object,
                required: true,
                default: {}
            },
            columnsWidth: {
                type: Array
            },

            itemsPerPage: {
                type: Number,
                default: 10
            },
            page: {
                type: Number,
                default: 1
            },
            totalItems: {
                type: Number,
                required: true,
                default: 0
            },
            mainColumn: {
                type: String
            },
            tableHeader: {
                type: String
            },
            currentTab: {}
        },
        computed: {
            totalPages() {
                if (this.totalItems === 0) return 0
                return Math.ceil(this.totalItems / this.itemsPerPage);
            }
        },
        methods: {
            changePage(pageNumber) {
                this.$emit('update:page', pageNumber);
            }
        }
    }
</script>

<template>
    <div :class="['table', tableName]">
        <div class="table-header">
            <div class="no-data" v-if="!this.data.length">{{ tableHeader }} отсутствуют.</div>

            <div :class="['table-header-elem', columnsWidth[index] ? 'col-'+columnsWidth[index] : 'col-0', mainColumn === key ? 'main-order' : '']" v-for="(value, key, index) in data[0]">
                <div v-if="columnsWidth[index] !== 0">
                    {{key}}
                </div>
            </div>
        </div>
        <div class="table-data" v-for="(elem, ind) in data">
            <div
                v-for="(value, key, index) in elem"
                :class="['table-data-elem', ind % 2===1 ? 'gray' : '', columnsWidth[index] ? 'col-'+columnsWidth[index] : 'col-0', mainColumn === key ? 'main-order' : '']"
            >
                <div v-if="columnsWidth[index] !== 0">
                    {{value}}
                    <div class="change-label" v-if="mainColumn === key">
                        <span @click="$router.push({path: `${currentTab}/${value}`})">Изменить</span>
                        <span>|</span>
                        <span>Удалить</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="pagination">
        <div @click.prevent="this.changePage(ind + 1)"
             :class="['pagination-elem', ind + 1 === page ? 'active-page' : '']"
             v-for="(elem, ind) in totalPages"
        >
            <span>{{ ind + 1 }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;
.table {
        width: 100%;
        overflow-x: scroll;

        -ms-overflow-style: none;
        scrollbar-width: none;

        text-align: left;
        box-shadow: $shadow;
    }
    .table-header {
        display: flex;
    }
    .table-data {
        display: flex;
    }

    .table-header .no-data {
        padding: 20px 25px;
        box-sizing: border-box;

    }

    .table-data-elem .change-label {
        display: flex;
        align-items: center;
        color: $hard-gray;
        font-size: 12px;
        font-weight: 400;

        gap: 5px;
    }

    .table-data-elem.main-order, .table-header-elem.main-order {
        order: 1
    }

    .table-data-elem, .table-header-elem {
        order: 2;
    }

    .table-data-elem .change-label span {
        cursor: pointer;
    }

    .table-header-elem {
        display: flex;
        align-items: center;
        padding: 1% 1.5%;
        background: $light-gray;
        font-size: 16px;
        font-weight: 500;
    }

    .table-data-elem {
        padding: 1% 1.5%;
        font-size: 16px;
        font-weight: 400;

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        gap: 5px;
    }

    .table-data-elem.gray {
        background: $light-gray;
    }

    .col-0 {
        display: none;
    }

    .pagination {
        margin-top: 30px;

        display: inline-flex;
        //gap: 10px;

        background: $light-gray;
        border-radius: 10px;
    }

    .pagination-elem {
        padding: 10px 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        min-width: 36px;
        box-sizing: border-box;
        cursor: pointer;

        font-size: 16px;
        font-weight: 400;
    }

    .pagination-elem.active-page {
        background: $black;
        color: $white;
    }
</style>
